import React, { useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

/* import function from store folder */
import { resetModel } from '../../store/components/modelSlice';

/* import fetch function */
import { DriverForgetPassword } from "../../services/forget";

const ForgetModel = () => {
    const dispatch = useDispatch();
    const [error, setError] = useState({});
    const [source, setSource] = useState({});
    const [sended, setSend] = useState(false);

    const cancelHandler = () => dispatch(resetModel());

    const changHandler = ({target: { name, value }}) => {
        const _source = Object.assign({}, source);

        delete error[name];

        _source[name] = value;
        
        setError(error);
        setSource(_source);
    };

    const submitHandler = (e) => {
        const isValidate = validate();
        
        if (!isValidate) return;
        
        DriverForgetPassword(source).then(response => {
            if (!Object.keys(response).length) {
                setSend(true);
            }
        })
        .catch(error => { setError({ mobilePhone: error.message }) });
    };

    const validate = () => {
        const checkLists = ['mobilePhone'];
        const _errors = {};

        checkLists.map( list => ( 
            (!source[list]) && (_errors[list] = '未輸入手機號碼')
        ));
        
        if (Object.keys(_errors).length) {
            setError(_errors);
            return false;
        }

        return true;
    };

    return (
        <Modal show={ true } onHide={ cancelHandler } centered>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
                <div className="subject-container">
                    <Form.Label hidden={ !!sended }>手機號碼</Form.Label>
                    <Form.Control type='tel' name='mobilePhone' placeholder='請輸入手機號碼' is-required={`${!!error.mobilePhone}`} hidden={ !!sended } onChange={ changHandler } />
                    <span hidden={ !sended }>已送出簡訊！</span>
                    <span hidden={ !!!error.mobilePhone }>發送失敗：{ error.mobilePhone }</span>
                </div>
                <div className="button-container">
                    <Button type="button" hidden={ !!sended } data-shadow hidden={ sended } onClick={ submitHandler }>送出</Button>
                    <Button type="button" hidden={ !sended } data-shadow onClick={ cancelHandler }>確定</Button>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default ForgetModel;